import {BaseModel} from '../../../shared/models';
import {ChacraTipoRendimiento} from "../../enums";
import {Padron} from "../padrones";
import {SueloCore} from "../suelos";
import {DibujoType} from "../dibujo.model";

export class Chacra extends BaseModel{
  rendimientoId: string;
  actualizarSoloGeom: boolean;
  aglutinador: string;
  aglutinadorReuneId: string;
  analisisSuelo: boolean;
  anio: number;
  asegurado: boolean;
  aseguradoraId:string;
  aseguradoraNombre: string;
  aseguradoraReuneId: string;
  beneficiario: boolean;
  borradoFecha: string;
  cultivo: string;
  cultivoAnterior: string;
  estadoCod: number;
  estadoDesc: string;
  fechaCosecha: string;
  fechaSiembra: string;
  geometria: string;
  geometriaElemento: string;
  geometriaId: number;
  geometriaTipo: string;
  k2O: string;
  n: string;
  p2O5: string;
  poliza: string;
  polizaFecha: string;
  predio: string;
  productorDocumento: string;
  productorNaturalezaJuridica: string;
  productorNombre: string;
  rendimiento: string;
  s: string;
  seguroAnterior: boolean;
  superficieAsegurada: string;
  superficieCosechada: string;
  superficieSembrada: string;
  tipoSeguro: number;
  tomador: boolean;
  zafra: number;
  padron?: {padrones?: RendimientoPadron[]};
  chacra?: {chacras?: RendimientoChacra[]};




  chacraNro: string;
  chacraNombre: string;
  chacraLocalidad: string;
  chacraArea: number;
  chacraDicose: number;
  chacraGeometria: string;

  padrones: Padron[] = [];
  suelos: SueloCore[] = [];
  suelosLoading?: boolean = false;

  // pediente
  chacraFactorLSEsManual: boolean;
  chacraFactorLSGeometriaAsignado: string;
  chacraFactorLSGeometriaLimitante: string;
  chacraFactorLSAsignado: number;
  chacraFactorLSLimitante: number;
  chacraFactorLAsignado: number;
  chacraFactorLLimitante: number;
  chacraFactorSAsignado: number;
  chacraFactorSLimitante: number;

  // suelo seleccionado
  chacraSueloLimitanteFactorK: number;
  chacraSueloAsignadoFactorK: number;
  chacraSueloAsignadoId: string;
  chacraSueloLimitanteId: number;
  chacraSueloAsignadoDsc: string;
  chacraSueloLimitanteDsc: string;
  chacraSueloAsignadoTolerancia: number;
  chacraSueloLimitanteTolerancia: number;
  chacraSueloAsignadoSlopeMax: number;
  chacraSueloAsignadoSlopeMin: number;
  chacraSueloLimitanteSlopeMax: number;
  chacraSueloLimitanteSlopeMin: number;

  chacraFactorRAsignado: number;
  chacraFactorRAutomatico: number;

  chacraLargoAsignado: number;
  chacraLargoLimitante: number;
  chacraPendienteAsignado: number;
  chacraPendienteLimitante: number;

  chacraRiesgoGeo: string;
  chacraNucleoId: string;
  chacraMecanicaApoyoCobertura: number;
  mecanicaDeApoyoId: number;

  chacraFactorP: number;
  chacraFactorPEsManual: boolean;
  tipoLaboreo: 'SD' | 'LC' | 'MX';

  chacraTerrazasLargo: number;
  chacraTerrazasConstruidas: boolean;

  chacraFactorAAsignado: number;
  chacraFactorALimitante: number;
  chacraFactorC: number;
}

export class ChacraGeo extends BaseModel{
  id: string;
  idUnico: string;
  geometria: string;
  type: string;
  objectid: string;
}

export interface RendimientoChacra{
  ChacraGDBId: string;
  ChacraGeometria: string;
  ChacraId: string;
  ChacraNucleoId: string;
  ChacraTipo: string;
}

export interface RendimientoPadron{
  PadronId: string;
  rendimientoId: string;
  Centroide: string;
  NroPadron: string;
  Departamento: string;
  PadronGDBId: string;
  PadronTipo: string;
}

export enum ChacraGeoFrom {
  AGLUTINADOR_POINT = 'RendAglutChacraPunto',
  AGLUTINADOR_POLYGON = 'RendAglutChacraPoligono',
  AGLUTINADOR_PADRON = 'RendAglutChacraPadron',
  ASEGURADORA_POINT = 'RendAsegChacraPunto',
  ASEGURADORA_POLYGON = 'RendAsegChacraPoligono',
  ASEGURADORA_PADRON = 'RendAsegChacraPadron',
}

export const ChacraGeoFromTypes = {
  [ChacraGeoFrom.AGLUTINADOR_POINT]: DibujoType.POINT,
  [ChacraGeoFrom.AGLUTINADOR_POLYGON]: DibujoType.POLYGON,
  [ChacraGeoFrom.AGLUTINADOR_PADRON]: DibujoType.POLYGON,
  [ChacraGeoFrom.ASEGURADORA_POINT]: DibujoType.POINT,
  [ChacraGeoFrom.ASEGURADORA_POLYGON]: DibujoType.POLYGON,
  [ChacraGeoFrom.ASEGURADORA_PADRON]: DibujoType.POLYGON,
};

export interface ChacrasCoreLS {
  FactorLS: string;
  FactorL: string;
  FactorS: string;
  Slope: number;
  SlopeLength: number;
  Geometry: string;
}

export interface MecanicaDeApoyo {
  mecanicaId: number;
  mecanicaNombre: string;
}

export const MECANICAS: MecanicaDeApoyo[] = [
  {mecanicaId: 4, mecanicaNombre: 'Siembra en contorno'},
  {mecanicaId: 5, mecanicaNombre: 'Cultivos en fajas en contorno'},
  {mecanicaId: 6, mecanicaNombre: 'Construcción de sistemas de terrazas'}
];

export function getChacraNombreNro(c: Chacra){
  if(c){
    let name = 's/n';
    if(c.cultivo !== '')
      name = c.cultivo;
    return `${c.aseguradoraId} - ${name}`;
  }
  return '';
}

export const TipoRendimientos = [
  {id: ChacraTipoRendimiento.AGLUTINADOR, name: 'Aglutinador'},
  {id: ChacraTipoRendimiento.ASEGURADORA, name: 'Aseguradora'},
];
